"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverflowDetector = exports.default = void 0;
var _react = require("react");
var _debounce = require("./debounce");
var _useResizeObserver = require("./useResizeObserver");
const useOverflowDetector = (targetRef, deps = []) => {
  const [hasOverflow, setHasOverflow] = (0, _react.useState)(false);
  let internalRef = (0, _react.useRef)(null);
  if (targetRef) {
    internalRef = targetRef;
  }
  const {
    width: targetWidth
  } = (0, _useResizeObserver.useResizeObserver)({
    targetRef: internalRef
  });
  const checkOverflow = (0, _debounce.debounce)(() => {
    const targetEl = internalRef.current;
    if (targetEl) {
      setHasOverflow(targetEl.scrollWidth > targetEl.clientWidth);
    }
  });
  (0, _react.useEffect)(() => {
    checkOverflow();
  }, [...deps, targetWidth]);
  return {
    checkOverflow,
    hasOverflow,
    ref: internalRef
  };
};
exports.useOverflowDetector = useOverflowDetector;
var _default = exports.default = useOverflowDetector;